import { ETabs } from 'src/components/Tabs';
import { TFieldsAssetArgs } from 'src/features/Assets/SingleAsset/SingleAsset.types';
import { ConfigType } from 'src/graphql';
import { TFieldsTemplateUnion } from 'src/utils/assetsFields/assetsFields.types';

const HeatPump = ({ configType }: TFieldsAssetArgs): TFieldsTemplateUnion[] => {
  return [
    {
      name: 'name',
      type: 'text',
      label: 'labels.ASSET_NAME',
      defaultValue: 'Custom Heat Pump',
      formView: ETabs.BASIC,
    },
    {
      name: 'consumptionKwhProfile',
      type: 'file',
      label: 'labels.UPLOAD_PROFILE',
      tooltipText: 'Please upload heat pump consumption profile here. ',
      formView: ETabs.BASIC,
      exclude: configType === ConfigType.CanaryNetwork,
    },
  ];
};

export default HeatPump;
